<!-- Bouton de fermeture -->
<ion-button class="close-button" fill="clear" (click)="onHangupAsync()">
	<ion-icon slot="icon-only" name="chevron-back"></ion-icon>
</ion-button>

<!-- Iframe Appel -->
<div #meeting id="meeting"></div>